<template>
  <div class="flex flex-row align-center h-full">
    <div class="flex flex-col align-center">
      <zt-avatar :text="getAvatarText" size="64px" />
      <h4 class="text-lg font-bold pt-2 "> {{ $t('message.dashboard.hello') }} {{ userName }}</h4>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "UserGreeting",

  computed: {
    ...mapState(['user']),
    userName() {
      return this.user.nickname ? this.user.nickname : `${this.user.nombre} ${this.user.apellido}`;
    },
    getAvatarText() {
      return this.user.nombre + ' ' + this.user.apellido
    },
  },
}
</script>

<style lang="scss" scoped></style>